import { defineComponent as S, computed as i, ref as l, watch as r, reactive as C, provide as _, openBlock as y, createBlock as T, resolveDynamicComponent as b, unref as g, normalizeClass as h, withCtx as E, renderSlot as k } from "vue";
import { EStepperSpacings as B, EStepperIndicatorTypes as n, EStepperOrientations as x, getStepperConditionalClasses as z, StepperSymbol as A } from "./novoui-vuejs42.js";
const N = /* @__PURE__ */ S({
  __name: "NStepper",
  props: {
    spacing: { default: B.medium },
    indicatorType: { default: n.bullet },
    active: { default: 0 },
    orientation: { default: x.vertical },
    completed: { default: () => [] }
  },
  emits: [
    /**
     * Emits the currently active step (index) each time the user navigates to another step
     */
    "update:active",
    /**
     * Emits the state of the currently active step (completed or not) each time the user completes a step
     */
    "update:complete"
  ],
  setup(s, { emit: d }) {
    const a = d, t = s, u = i(() => t.indicatorType), o = l(t.active), p = l(t.completed), m = i(() => z(t));
    function v(e) {
      a("update:active", e), o.value = e;
    }
    r(
      () => t.active,
      (e, c) => {
        a("update:active", e), o.value = e;
      }
    ), r(
      () => t.completed,
      (e, c) => {
        a("update:complete", e), p.value = e;
      }
    );
    const f = C({
      indicatorType: u,
      active: o,
      completed: p,
      updateActiveState: v
    });
    return _(A, f), (e, c) => (y(), T(b(t.indicatorType === g(n).numbered ? "ol" : "ul"), {
      class: h(m.value)
    }, {
      default: E(() => [
        k(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  N as default
};
